export default {
	ModalTitle: 'Phân tích biến động số liệu chi phí',
	TimePeriod: 'Thời gian',
	CostType: 'Loại chi phí',
	AllCostTypes: 'Tất cả',
	Currency: 'Đơn vị tính',
	BusinessExpense: 'Chi phí doanh nghiệp',
	CurrentTotalCost: 'Tổng chi phí hiện tại',
	ComparedToPrevious: 'So với kỳ trước',
	MonthlyFluctuation: 'Biến động theo tháng',
	HighestCost: 'Tổng chi phí cao nhất',
	LowestCost: 'Tổng chi phí thấp nhất',
	SuddenIncrease: 'Tăng đột biến',
	Month: 'Tháng',
	Conclusion: 'Kết luận',
	Trend: 'Xu hướng',
	Top3Categories: 'Top 3 loại chi phí biến động mạnh Quý',
	DetailedComparison: 'So sánh chi tiết',
	CostCategory: 'Loại chi phí',
	PreviousPeriod: 'Kỳ trước',
	CurrentPeriod: 'Kỳ này',
	Change: 'Biến động',
	ProportionOfTotal: 'Tỷ trọng trên tổng chi phí',
	Recommendations: 'Lời khuyên',
	NotablePoints: 'Một số điểm đáng chú ý',
	SuggestedActions: 'Đề xuất hành động',
	ReportingPeriod: 'Kỳ báo cáo',
	ComparisonPeriod: 'kỳ so sánh',
	Reference:
		'Kết quả chỉ mang tính chất tham khảo, bạn nên kiểm tra lại thông tin quan trọng để đảm bảo tính đúng đắn'
};
